import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c3b21ece&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c3b21ece&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b21ece",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\iotcarduserui\\iotcardpc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3b21ece')) {
      api.createRecord('c3b21ece', component.options)
    } else {
      api.reload('c3b21ece', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c3b21ece&scoped=true", function () {
      api.rerender('c3b21ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/terminal/index.vue"
export default component.exports